<template>
  <div>
    <div class="swap-form">
      <div class="tips1">{{ $t("asset.metaverseSwapTips1") }}</div>
      <!-- <div class="tips3"></div> -->
      <div class="tips3">
        {{ $t("asset.metaverseSwapTips2") }}<br />{{
          $t("asset.metaverseSwapTips3")
        }}
      </div>

      <div class="f-group" v-if="DATA.metaverseBurnDID">
        <div class="f-title">{{ $t("asset.metaverseBurnDID") }}</div>
        <div class="f-input-btn">
          <input type="text" readonly="true" :value="DATA.metaverseBurnDID" />
          <div class="btn" @click="onMvsDIDCopy">{{ $t("global.copy") }}</div>
        </div>
      </div>

      <div class="f-group" v-if="DATA.metaverseBurnAddress">
        <div class="f-title">{{ $t("asset.metaverseBurnAddress") }}</div>
        <div class="f-input-btn">
          <input
            type="text"
            readonly="true"
            :value="DATA.metaverseBurnAddress"
          />
          <div class="btn" @click="onMvsAddressCopy">
            {{ $t("global.copy") }}
          </div>
        </div>
      </div>

      <div class="f-group">
        <div class="f-title">{{ $t("asset.metaverseBurnRemark") }}</div>
        <div class="f-input-btn">
          <input type="text" readonly="true" :value="address" />
          <div class="btn" @click="onAddressCopy">{{ $t("global.copy") }}</div>
        </div>
      </div>
    </div>
    <div class="swap-form" v-if="swapStart && now < swapStart">
      <div class="tips tips-red">
        {{ $t("tips.swapStartAt").replace("{d}", swapStart.toLocaleString()) }}
      </div>
    </div>
  </div>
</template>

<script>
import DATA from "@/data/data.js";
export default {
  data() {
    return {
      DATA,
      swapStart: new Date("Thu Sep 25 2020 12:00:00 GMT+0800"),
      //swapStart: new Date("Thu Sep 25 2020 11:19:00 GMT+0800"),
      now: new Date(),
    };
  },
  mounted() {
    let that = this;
    setInterval(() => {
      that.now = new Date();
    }, 1000);
  },
  // 参数
  methods: {
    onAddressCopy() {
      this.copy(this.address);
    },
    onMvsDIDCopy() {
      this.copy(DATA.metaverseBurnDID);
    },
    onMvsAddressCopy() {
      this.copy(DATA.metaverseBurnAddress);
    },
    copy(txt) {
      let that = this;
      that.$copyText(txt).then(
        (e) => {
          that.$Message.success({
            background: true,
            duration: 3,
            content: that.$t("global.copySuccess"),
          });
        },
        (e) => {
          that.$Message.error({
            background: true,
            duration: 3,
            content: that.$t("global.copyFail"),
          });
        }
      );
    },
  },
  computed: {
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./AssetSwapForm.less");
</style>